import Card from "react-bootstrap/Card";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ListGroup from "react-bootstrap/ListGroup";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import styled from "styled-components";
import LazyLoad from "react-lazyload";
import ImagenDefault from "./../../img/imgDefault.png";
import { styled as muiStyled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import Boton from '../eventos/Boton';
import './draft-conver.css';
import copy from 'copy-to-clipboard';
import '../basicos/cardBlog.css';

function convertirHtmlATextoPlano(html) {
  if (!html) return '';
  
  const tempDiv = document.createElement('div');
  
  const htmlConSaltos = html
    .replace(/<\/?(h[1-6]|p|div|br|li|ul|ol)>/gi, '\n')
    .replace(/<\/?(h[1-6]|p|div|li|ul|ol)[^>]*>/gi, '\n');
  
  tempDiv.innerHTML = htmlConSaltos;
  
  const textoPlano = tempDiv.textContent || tempDiv.innerText || '';
  
  const textoLimpio = textoPlano
    .replace(/[ \t]+/g, ' ')
    .replace(/\n\s+/g, '\n')
    .replace(/\s+\n/g, '\n')
    .replace(/\n+/g, '\n')
    .trim();
  
  const lineas = textoLimpio.split('\n').filter(linea => linea.trim() !== '');
  const numeroDeLineas = lineas.length;
  
  const MAX_CARACTERES = 200;
  const MAX_LINEAS = 3;
  
  const demasiadoLargo = textoLimpio.length > MAX_CARACTERES;
  const demasiadasLineas = numeroDeLineas > MAX_LINEAS;
  
  if (demasiadasLineas) {
    const lineasLimitadas = lineas.slice(0, MAX_LINEAS).join('\n');
    if (lineasLimitadas.length > MAX_CARACTERES) {
      return lineasLimitadas.substring(0, MAX_CARACTERES) + '...';
    }
    return lineasLimitadas + '...';
  } else if (demasiadoLargo) {
    return textoLimpio.substring(0, MAX_CARACTERES) + '...';
  }
  
  return textoLimpio;
}


const copiarEnlace = ({ enlace, id, setCopiados }) => {
  const urlCompleta = `${window.location.origin}${enlace}`;
  copy(urlCompleta);

  setCopiados((prev) => ({ ...prev, [id]: true }));

  setTimeout(() => {
    setCopiados((prev) => ({ ...prev, [id]: false }));
  }, 1000);
};




function CardBlog({ elementosLista }) {
  const [copiados, setCopiados] = useState({});
  console.log("elementosLista en CardBlog", elementosLista);
  const cargaPublicaciones = (elemento) => {
    return (        
      <>
        <Columna lg={12} sm={12} md={12} key={elemento.Id}>
          <EstilosCards className="animacionContenedor">
            <Card.Body>
              <Row>
                <Col lg={4} xs={12}>
                  <LazyLoad height={200} once>
                    <Card.Img
                      variant="top"
                      src={elemento.imgPortada ? `${process.env.REACT_APP_API_URL}/api/comunicacion/blogs/imagen/${elemento.Id}/${elemento.imgPortada}` : ImagenDefault}
                      onError={(e) => {
                        e.target.src = ImagenDefault;
                      }}
                      className="imagen-blog"
                    />
                  </LazyLoad>
                </Col>
                <Col  xs={12} className="text-center d-lg-none " >
                  <FechaTitulo>
                    <p>
                      {dayjs(elemento.fechaPublicacion, "YYYY-MM-DD").format("D/M/YYYY")}
                    </p>
                  </FechaTitulo>
                </Col>

                <Col lg={6} xs={12}>
                  <BootstrapTooltip title={elemento.titulo.toUpperCase()} placement="top">
                    <Titulo title={elemento.titulo.length > 30 ? elemento.titulo : ""}>
                      {elemento.titulo}
                    </Titulo>
                  </BootstrapTooltip>
                  <ContenidoTexto>
                    {convertirHtmlATextoPlano(elemento.contenido)}
                  </ContenidoTexto>


                  <Row className="justify-content-md-center">
                    <Col xs={5} className="text-center">
                      <ListGroup className="list-group-flush" style={{ color: "white" }}>
                        <ListGroup.Item>
                          <Boton to={`/blog/${elemento.url}`} className="animacionBotonDerecho" >LEER MÁS +</Boton>
                        </ListGroup.Item>
                      </ListGroup>
                    </Col>
                    <Col xs={5} className="text-center">
                      <ListGroup className="list-group-flush" style={{ color: "white" }}>
                        <ListGroup.Item>
                          <Boton
                            as="button"
                            onClick={() => copiarEnlace({ enlace: `/blog/${elemento.url}`, id: elemento.Id, setCopiados })}
                            className="boton-uniforme animacionBotonIzquierdo"
                            style={{ fontSize: "1.0rem" }}
                          >
                            {/* <IconosGenerales id="compartir" hover={hovered} /> */}
                            <b>{copiados[elemento.Id] ? "¡Copiado!" : "Copiar enlace"}</b>
                          </Boton>


                        </ListGroup.Item>
                      </ListGroup>
                    </Col>
                  </Row>

                </Col>

                <Col lg={2}  className="text-center d-none d-lg-block">
                  <FechaTitulo>
                    <p>
                      {dayjs(elemento.fechaPublicacion, "YYYY-MM-DD").format("D/M/YYYY")}
                    </p>
                  </FechaTitulo>
                </Col>
              </Row>
            </Card.Body>
          </EstilosCards >
        </Columna >
      </>


    );
  };

  return <Row className="g-4">{elementosLista.map((elemento) => cargaPublicaciones(elemento))}</Row>;
}


const BootstrapTooltip = muiStyled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));


const Columna = styled(Col)`
  margin-top: 1% !important;
  margin-bottom: 2% !important;
  align-items: center !important;
  justify-content: center;
  padding: 0 15px;
`;

const EstilosCards = styled(Card)`
  text-align: left;
  margin-bottom: 2rem;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  transition: transform 0.2s ease-in-out;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0,0,0,0.15);
  }

  a {
    text-decoration: none;
    font-weight: bolder;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    font-size: 1rem;
  }

  .imagen-blog {
    width: 100%;
    height: 250px;
    object-fit: cover;
    border-radius: 8px;
  }

  .card-img-top {
    width: 100%;
    height: 12rem;
    object-fit: cover;
  }
  .card-img-right {
    width: 30rem;
    height:202rem;
    object-fit: cover;
  }
`;





const FechaTitulo = styled.div`
  padding: 10px 0;

  p {
    font-size: 18px;
    font-weight: 600;
    color: #28a745;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
`;

const Titulo = styled.p`
  text-align: center;
  font-size: 2rem;
  font-weight: bolder;
  margin-bottom: 1rem;
  color: #333;
  line-height: 1.3;
`;

const ContenidoTexto = styled.p`
  padding-left: 20px;
  text-decoration: none;
  font-size: 1.1rem;
  line-height: 1.6rem;
  margin-bottom: 1.5rem;
  color: #666;
  text-align: justify;
  word-spacing: 1px;
  min-height: 2rem;
  white-space: pre-line;
`;

CardBlog.propTypes = {
  elementosLista: PropTypes.array.isRequired,
};

export default CardBlog;
